const pad2 = (value) => String(value).padStart(2, "0");

const convertToMMYYDDDD = (value) => {
  if (value) {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return null;
    }

    return `${pad2(date.getMonth() + 1)}/${pad2(date.getDate())}/${date.getFullYear()}`;
  }

  return null;
}

const convertFromMMYYDDDD = (value) => {
  if (value) {
    const [month, day, year] = String(value).split('/').map((part) => Number(part));
    if (!month || !day || !year) {
      return null;
    }

    return new Date(year, month - 1, day);
  }

  return null;
}

/**
 * Checks a give date is valid, not null / empty
 *
 * @param date
 * @returns {boolean}
 */
const isValid = (date) => {
  return date && JSON.stringify(date).trim() !== '';
}


module.exports = {
  convertToMMYYDDDD,
  convertFromMMYYDDDD,
  isValid
}
